/**
 * Origin tag for the y-xyflow binding.
 *
 * DESIGN: `Symbol.for` (global registry) so the same symbol is
 * returned regardless of which module instance imported it. This
 * matters when the binding and the consumer live in different module
 * realms (e.g. different Vite chunks). Consumers can access the same
 * symbol via `Symbol.for("y-xyflow-local")` without importing from
 * this package.
 *
 * The origin tag is passed to `ydoc.transact(..., LOCAL_ORIGIN)` on
 * every store → Yjs write. The Yjs → store observer skips transactions
 * carrying this origin to prevent the cycle:
 *
 *   store mutates → ymap.set → observe fires → store mutates → …
 */
export const LOCAL_ORIGIN = Symbol.for("y-xyflow-local");

/**
 * Origin for the ONE-TIME initial push (session originator seeds the empty doc
 * from the store). Kept distinct from LOCAL_ORIGIN so consumers can leave it OUT
 * of their UndoManager's trackedOrigins — the initial content (e.g. the default
 * Home page) must NOT be an undoable "action" on a brand-new site. The Yjs→store
 * observer skips it too (same as LOCAL_ORIGIN).
 */
export const HYDRATE_ORIGIN = Symbol.for("y-xyflow-hydrate");
